import { createContext } from "react"

export const EventsListContext = createContext()
